<template>
  <CModal
    size="lg"
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <closeButton :setModalVisible="setModalVisible" />
      <CContainer style="padding: 3.125rem">
        <CRow class="modal-title">
          <div class="modal-title">Banner</div>
        </CRow>
        <CRow class="modal-detail">
          <input placeholder="BANNER TITLE" class="input input-text" />
        </CRow>
        <CRow class="modal-detail">
          <vue-dropzone
            ref="myVueDropzone"
            id="customdropzone"
            :options="dropzoneOptions"
            class="input"
          />
        </CRow>
        <CRow alignHorizontal="between" class="modal-detail">
          <div style="align-content: center; width: 70%">
            <input placeholder="FILE NAME.JPG" class="input input-text" />
          </div>
          <div>
            <label for="inputFile">
              <div
                class="button button-green"
                style="width: 9.375rem !important; justify-content: center"
              >BROWSE</div>
            </label>
            <input id="inputFile" type="file" accept="image/*" class="button button-grey" />
          </div>
        </CRow>
        <CRow class="modal-detail">
          <div class="input-label">Link</div>
          <input class="input input-text" placeholder="Link address" />
        </CRow>
        <CRow alignHorizontal="between" class="modal-detail">
          <div>
            <div class="input-label">Show Date</div>
            <input type="date" class="input input-date" />
          </div>
          <div>
            <div class="input-label">Expired Date</div>
            <input type="date" class="input input-date" />
          </div>
          <div style="width: 9.375rem !important; justify-content: center" />
        </CRow>
        <CRow alignHorizontal="between">
          <div>
            <div class="input-label">Show Time</div>
            <input type="date" class="input input-date" />
          </div>
          <div>
            <div class="input-label">Expired Time</div>
            <input type="date" class="input input-date" />
          </div>
          <div>
            <div
              class="button button-green"
              style="width: 9.375rem !important; justify-content: center"
            >ADD</div>
          </div>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
import closeButton from "./closeButton";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "BannerModal",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function
  },
  components: {
    closeButton,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        autoProcessQueue: false,
        thumbnailWidth: 996, // px
        thumbnailHeight: 212,
        addRemoveLinks: true,
        maxFiles: 1,
        headers: { "My-Awesome-Header": "header value" }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
[type="file"] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}
</style>